import './zone-flags';
import 'zone.js/dist/zone';

window.Buffer = window.Buffer || require('buffer').Buffer;
